import React from 'react';
import {FieldViewSmallProps} from "../../../../render/view-small";

export default function FieldTimeSpent_ViewSmall(props:FieldViewSmallProps) {

    let value = _.get(props.model, props.field.fieldId, null)

    if (_.isNil(value)) {
        return false
    }

    return (
        <div className={Classes("ui5-txt-less-important-small", "fl-ac", props.className)}>
            <span className="txt-truncate">{gd.utils.minutesHumanize(value)}</span>
        </div>
    );
}
